<template>
  <div style="border-bottom: 1px solid rgb(210, 213, 217)">
    <layout-content-menu :items="items" white :selected="selected" stacked />
  </div>
</template>

<script lang="ts">
import "reflect-metadata";
import i18n from "@/plugins/i18n";
import { MESSAGE_TYPES } from "@/static/messageTypes";
import { filterCapitalize } from "@/filters/capitalize";
import { Component, Vue } from "vue-property-decorator";
import { AlertModel } from "@/models/components/popup/Alert";
import TopMenuItemModel from "@/models/components/layout/TopMenuItemModel";
import LayoutContentMenu from "@/components/shared/layout/LayoutContentMenu.vue";
import { CustomClickActionFunction } from "@/models/components/CustomClickActionFunction";
import { EditTemporaryRoleModel } from "@/models/api/administration/temporaryRoles/EditTemporaryRole";

export enum ADMINISTRATION_USERS_TABS {
  BasicInformation,
  Roles,
  TemporaryRoles,
  AgentCodes,
  Cashboxes,
}

@Component({
  components: { LayoutContentMenu },
})
export default class AdministrationUsersContentMenu extends Vue {
  clickFunction: CustomClickActionFunction = (item: TopMenuItemModel, vue) => {
    vue.$store.direct.commit.administration.users.setSelectedTab(item.value as ADMINISTRATION_USERS_TABS);
  };

  get selected(): ADMINISTRATION_USERS_TABS {
    return this.$store.direct.state.administration.users.selectedTab;
  }

  items: Array<TopMenuItemModel> = [
    {
      text: filterCapitalize(this.$t("basicInfo")),
      value: ADMINISTRATION_USERS_TABS.BasicInformation,
      action: this.clickFunction,
    } as TopMenuItemModel,
    {
      text: filterCapitalize(this.$t("roles")),
      value: ADMINISTRATION_USERS_TABS.Roles,
      action: this.clickFunction,
    } as TopMenuItemModel,
    {
      text: filterCapitalize(this.$t("temporaryRoles")),
      value: ADMINISTRATION_USERS_TABS.TemporaryRoles,
      action: this.clickFunction,
      appendText: filterCapitalize(this.$t("addTemporaryRole")),
      appendAction: () => {
        if (this.$store.direct.state.administration.users.selectedTab !== ADMINISTRATION_USERS_TABS.TemporaryRoles) {
          this.$store.direct.dispatch.popup.addAlert({
            content: filterCapitalize(i18n.t("activateTabFirst")),
            title: filterCapitalize(i18n.t("warning")),
            type: MESSAGE_TYPES.Warning,
          } as AlertModel);
        } else this.$store.direct.dispatch.administration.users.openEditRoleDialog(new EditTemporaryRoleModel());
      },
    } as TopMenuItemModel,
    {
      text: filterCapitalize(this.$t("agentCodes")),
      value: ADMINISTRATION_USERS_TABS.AgentCodes,
      action: this.clickFunction,
      appendText: filterCapitalize(this.$t("addAgentCode")),
      appendAction: () => {
        if (this.$store.direct.state.administration.users.selectedTab !== ADMINISTRATION_USERS_TABS.AgentCodes) {
          this.$store.direct.dispatch.popup.addAlert({
            content: filterCapitalize(i18n.t("goToAgentCodesFirst")),
            title: filterCapitalize(i18n.t("warning")),
            type: MESSAGE_TYPES.Warning,
          } as AlertModel);
        } else this.$store.direct.dispatch.administration.users.newAgentCodeDialogOpen();
      },
    } as TopMenuItemModel,
    {
      text: filterCapitalize(this.$t("cashboxes")),
      value: ADMINISTRATION_USERS_TABS.Cashboxes,
      action: this.clickFunction,
    } as TopMenuItemModel,
  ];
}
</script>

<style scoped></style>
